import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Image1 from "../../assests/ashirvadham.jpg";
import Image2 from "../../assests/img2.jpg";
import Image3 from "../../assests/img3.jpg";
import Image4 from "../../assests/img4.jpg";

function GetInvolved() {
  const [active, setActive] = useState(0);
  const items = [
    {
      num: "#1",
      title: "BE A PRAYER PARTNER",
      image: Image1,
      path: "/prayer-partner",
      desc: "Become a prayer partner for Christ For India and connect with us. We need prayer covering for the work in India! We believe in the power of prayer. For over 41 years, our children and students pray each morning for our needs and God answers the prayers. He is a Faithful God!",
    },
    {
      num: "#2",
      title: "SUPPORT US",
      image: Image2,
      path: "/sponsorship-programme",
      desc: "Your financial support makes a real difference in the lives of children, communities, and church planters across India. Every gift goes directly toward our mission work.",
    },
    {
      num: "#3",
      title: "INVITE US",
      image: Image3,
      path: "/invite-us",
      desc: "Invite us to speak at your church or event. We love sharing stories of God's faithfulness in India and connecting with communities who want to make a difference.",
    },
    {
      num: "#4",
      title: "GO TO INDIA",
      image: Image4,
      path: "/go-to-india",
      desc: "Join a mission trip to India! Experience firsthand the incredible work God is doing through Christ For India and serve alongside our national partners.",
    },
  ];

  return (
    <section className="get-involved">
      <div className="section-title">
        <span>How You Can Help</span>
        <h2>Get Involved!</h2>
        <div className="dots">••••••</div>
      </div>
      <div className="involved-layout">
        <div className="involved-sidebar">
          {items.map((item, i) => (
            <div
              key={i}
              onClick={() => setActive(i)}
              className={`sidebar-item ${active === i ? "active" : ""}`}
            >
              <span>{item.num}</span> {item.title}
            </div>
          ))}
        </div>
        <div className="involved-content">
          <img
            src={items[active].image}
            className="involved-image"
            alt={items[active].title}
          />
          <div className="involved-text">
            <p>{items[active].desc}</p>
            <Link to={items[active].path}>READ MORE</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetInvolved;
